import { vega } from "vega-embed";
import equal from "fast-deep-equal";
export function updateMultipleDatasetsInView(view, data) {
    Object.keys(data).forEach((name) => {
        const value = data[name];
        const getType = {};
        if (value) {
            if (!!value && getType.toString.call(value) === "[object Function]") {
                const parsedValue = value;
                parsedValue(view.data(name));
            }
            else {
                view.change(name, vega
                    .changeset()
                    .remove(() => true)
                    .insert(value));
            }
        }
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function shallowEqual(a = {}, b = {}, ignore = new Set()) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    return (a === b ||
        (aKeys.length === bKeys.length &&
            aKeys.filter((k) => !ignore.has(k)).every((key) => a[key] === b[key])));
}
export function removeSignalListenersFromView(view, signalListeners) {
    const signalNames = Object.keys(signalListeners);
    signalNames.forEach((signalName) => {
        try {
            view.removeSignalListener(signalName, signalListeners[signalName]);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.warn("Cannot remove invalid signal listener.", error);
        }
    });
    return signalNames.length > 0;
}
export function addSignalListenersToView(view, signalListeners) {
    const signalNames = Object.keys(signalListeners);
    signalNames.forEach((signalName) => {
        try {
            view.addSignalListener(signalName, signalListeners[signalName]);
        }
        catch (error) {
            console.warn("Cannot add invalid signal listener.", error);
        }
    });
    return signalNames.length > 0;
}
export function getUniqueFieldNames(objects) {
    const fields = new Set();
    objects.forEach((o) => {
        Object.keys(o).forEach((field) => {
            fields.add(field);
        });
    });
    return fields;
}
export function computeSpecChanges(newSpec, oldSpec) {
    if (newSpec === oldSpec)
        return false;
    const changes = {
        width: false,
        height: false,
        isExpensive: false,
    };
    const hasWidth = "width" in newSpec || "width" in oldSpec;
    const hasHeight = "height" in newSpec || "height" in oldSpec;
    if (hasWidth &&
        (!("width" in newSpec) ||
            !("width" in oldSpec) ||
            newSpec.width !== oldSpec.width)) {
        if ("width" in newSpec && typeof newSpec.width === "number") {
            changes.width = newSpec.width;
        }
        else {
            changes.isExpensive = true;
        }
    }
    if (hasHeight &&
        (!("height" in newSpec) ||
            !("height" in oldSpec) ||
            newSpec.height !== oldSpec.height)) {
        if ("height" in newSpec && typeof newSpec.height === "number") {
            changes.height = newSpec.height;
        }
        else {
            changes.isExpensive = true;
        }
    }
    const fieldNames = [...getUniqueFieldNames([newSpec, oldSpec])].filter((f) => f !== "width" && f !== "height");
    if (fieldNames.some((field) => !(field in newSpec) ||
        !(field in oldSpec) ||
        !equal(newSpec[field], oldSpec[field]))) {
        changes.isExpensive = true;
    }
    return changes.width !== false ||
        changes.height !== false ||
        changes.isExpensive
        ? changes
        : false;
}
export function combineSpecWithDimension(spec, options) {
    const { width, height } = options;
    if (typeof width !== "undefined" && typeof height !== "undefined") {
        return Object.assign(Object.assign({}, spec), { width, height });
    }
    if (typeof width !== "undefined") {
        return Object.assign(Object.assign({}, spec), { width });
    }
    if (typeof height !== "undefined") {
        return Object.assign(Object.assign({}, spec), { height });
    }
    return spec;
}
//# sourceMappingURL=utils.js.map